<template>
  <component
    :is="getElement(promo.Link)"
    :to="promo.Link"
    class="product-promo"
  >
    <img
      v-if="promo?.Image?.url"
      :src="promo.Image.url"
      class="product-promo__image"
      :alt="promo.Title"
    >
    <div class="product-promo__content">
      <div class="product-promo__name">
        {{ promo.Title }}
      </div>
      <div class="product-promo__description">
        {{ promo.Description }}
      </div>
    </div>
  </component>
</template>

<script setup lang="ts">
import { AppLink } from '#components'

export interface Props {
  promo: {
    Title: string
    Description?: string
    Image?: {
      url: string
    }
    ActiveFrom: string
    ActiveUntil: string
    Link?: string
  }
}

defineProps<Props>()

const getElement = (to: any) => {
  return to ? AppLink : 'span'
}
</script>

<style>
@import url("~layers/app/components/Product/Promo.css");
</style>
